import { section } from "@/neon";
import { animateImageWithTextSplit } from "@/lib/animation";

section("image-with-text-split", {
  onLoad() {
    this.animateImageWithTextSplit = animateImageWithTextSplit(this.container);
  },

  onUnload() {
    this.animateImageWithTextSplit?.destroy();
  },
});
